import './FloatingPlaceholder.css';
import React from 'react';
import classNames from 'classnames';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import Textarea from 'react-textarea-autosize';
import { Field } from 'formik';
import { EVO } from '../EVO';
import { Check, Info } from 'react-feather';
import { useState } from 'react';

export const FloatingPlaceholder = ({ field, info, form: { errors }, ...props }) => (
    <div className={classNames("floating-placeholder", { 'center': props.center, 'small': props.small, 'inline': props.inline })}>
        <div className={classNames('floating-label', { 'errored': errors[field.name] })}>
            <input type="text" {...field} {...props} id={field.name} />
            <label htmlFor={field.name}>{props.placeholder}</label>
            {info && <span className="floating-info" data-tip={info}><Info color="black" /></span>}
        </div>
        {errors[field.name] && <div className="error">{errors[field.name]}</div>}
    </div>
);

export const FloatingPlaceholderTextArea = ({ field, form: { errors }, ...props }) => (
    <div className={classNames("floating-placeholder", { 'center': props.center })}>
        <div className={classNames('floating-label', { 'errored': errors[field.name] })}>
            <Textarea {...field} {...props} id={field.name} />
            <label htmlFor={field.name}>{props.placeholder}</label>
        </div>
        {errors[field.name] && <div className="error">{errors[field.name]}</div>}
    </div>
);

export const HiddenErrorField = ({ field, form: { errors }, ...props }) => (
    errors[field.name] ? <div className={classNames("floating-placeholder", { 'center': props.center })}>
        <div className="error">{errors[field.name]}</div>
    </div> : null
);



export const FloatingCheckbox = ({ field, placeholder, info, ...props }) => (
    <label className="floating-checkbox">
        <span className={classNames('checkbox', { 'checked': field.value })}>{field.value && <Check color="white" />}</span>
        <input {...field} type="checkbox" checked={field.value} />
        {placeholder && <span className="label">{placeholder}</span>}
        {info && <span className="floating-info-checkbox" data-tip={info} data-class="floating-info-checkbox-modal"><Info color="black" /></span>}
    </label>
);

export const FloatingCheckboxBasic = ({ value, placeholder, info, ...props }) => (
    <label className="floating-checkbox">
        <span className={classNames('checkbox', { 'checked': value })}>{value && <Check color="white" />}</span>
        <input type="checkbox" checked={value} {...props} />
        <span className="label">{placeholder}</span>
        {info && <span className="floating-info-checkbox" data-tip={info} data-class="floating-info-checkbox-modal"><Info color="black" /></span>}
    </label>
);

export const FloatingPlaceholderSelect = ({ options, 
    field, form,
    form: { errors }, ...props }) => (
        <div className={classNames("floating-placeholder", "floating-placeholder-select", { 'center': props.center })}>
            <div className={classNames('floating-label', { 'errored': errors[field.name] })}>
                <Select
                    options={options}
                    name={field.name}
                    value={findOptions(options, field)}
                    onChange={(option) => form.setFieldValue(field.name, getOptionValue(option))}
                    onBlur={field.onBlur}
                    isSearchable={field.isSearchable}
                    isMulti={field.isMulti}
                    isClearable={field.isClearable}
                    classNamePrefix="floating-placeholder-select"
                    id={field.name}
                    {...props}
                    placeholder="Select..."
                />
                <label htmlFor={field.name}>{props.placeholder}</label>
            </div>
            {errors[field.name] && <div className="error">{errors[field.name]}</div>}
        </div>
    );

export const findOptions = (options, field) => {
    if (options && options.length > 0) {
        if (options[0]['options']) {
            // Group
            var result = options.reduce((a, b) => a.concat(b.options), []);
            return result.find(option => option.value === field.value);
        }
        else if (Array.isArray(field.value)) {
            // In a multi..
            return options.filter(o => field.value.includes(o.value));
        }
        else {
            return options.find(option => option.value === field.value);
        }
    }

    return '';
};

export const getOptionValue = (option) => {
    if (!option) return null;
    if (Array.isArray(option)) {
        return option.map(o => o.value);
    }
    
    return option.value;
};

export const FloatingPlaceholderCreatableSelect = ({ options, field, form, form: { touched, errors }, ...props }) => {
    const [actualOptions, setActualOptions] = useState(options);
    const handleCreate = (inputValue) => {
        const newOption = createOption(inputValue);
        setActualOptions([...actualOptions, newOption]);
        form.setFieldValue(field.name, [...field.value, inputValue]);
    };  
      return (<div className="floating-placeholder floating-placeholder-select">
            <div className={classNames('floating-label', { 'errored': touched[field.name] && errors[field.name] })}>
                <CreatableSelect
                  options={actualOptions}
                    name={field.name}
                    value={findOptions(actualOptions, field)}
                    onChange={(option) => form.setFieldValue(field.name, getOptionValue(option))}
                    onBlur={field.onBlur}
                    onCreateOption={handleCreate}
                    classNamePrefix="floating-placeholder-select"
                    id={field.name}
                    {...props}
                />
                <label htmlFor={field.name}>{props.placeholder}</label>
            </div>
            {touched[field.name] &&
                errors[field.name] && <div className="error">{errors[field.name]}</div>}
        </div>)
    };

const createOption = (label) => ({
    label,
    value: label.toLowerCase().replace(/\W/g, ''),
});

export const GroupedFields = (groupedKeys, values, toShow, showAll) => {
    return Object.keys(groupedKeys).map(groupKey => {
        let groupsWithFields = renderGroup(groupedKeys, groupKey, values, toShow, showAll).filter(a => a != null);
        if (groupsWithFields.length === 0) return null;
        return (<div className="full" key={groupKey}><h3>{EVO.deCamel(groupKey)}</h3>{groupsWithFields}</div>)
    })
};

export const DefaultValuesFromGroupedFields = (groupedKeys, options) => {
    options = Object.assign({}, { overrideDefaultValue: false, additionalProps: {} }, options);
    let retVal = options.additionalProps;
    Object.keys(groupedKeys).forEach(groupKey => {
        var obj = groupedKeys[groupKey];
        if (obj.items) {
            Object.keys(obj.items).forEach(key => {
                retVal[key] = options.overrideDefaultValue ? '' : (obj.items[key].defaultValue || '');
            });
        }
    });

    return retVal;
};

const renderGroup = (groupedKeys, groupKey, values, toShow, showAll) => {
    const obj = groupedKeys[groupKey];
    return Object.keys(obj.items).map(key => {
        const opts = Object.assign({}, { type: 'text', placeholder: EVO.deCamel(key) }, obj.default, obj.items[key] || {});
        var result = null;

        if (showAll || !toShow || toShow.indexOf(key) > -1) {
            if (opts.noShow) {
                result = null;
            }
            else if (opts.field) {
                result = opts.field({ values: values, key: key });
            }
            else if (opts.type) {
                if (opts.type === 'select' && opts.options) {
                    result = (<Field key={key} name={key} component={FloatingPlaceholderSelect} options={opts.options} placeholder={opts.placeholder} />);
                }
                else if (opts.type === 'textarea') {
                    result = (<Field key={key} name={key} component={FloatingPlaceholderTextArea} placeholder={opts.placeholder} />);
                }
                else if (opts.type === 'decimal') {
                    result = (<Field key={key} name={key} type="number" step="0.1" component={FloatingPlaceholder} placeholder={opts.placeholder} />);
                }
                else {
                    result = (<Field key={key} type={opts.type} name={key} component={FloatingPlaceholder} placeholder={opts.placeholder} />);
                }
            }
        }

        if (obj.preRender) {
            result = obj.preRender(key, result, opts);
        }

        return result;
    });
};


// WEBPACK FOOTER //
// ./src/components/FloatingPlaceholder.js